import Vue from 'vue';
import Vuex from 'vuex';
import * as modules from './modules';
import CONFIG from '../common/config';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        routerKey: Math.random(),
        pagesize: CONFIG.PAGE_SIZE,
    },
    mutations: {
        save(state, payload) {
            for (var key in payload) {
                state[key] = payload[key]
            }
        },
    },
    modules
})
